import { createContext } from 'react';

export const ReportNavigationContext = createContext<((reportId: string) => void) | undefined>(undefined);
export const OrganizationReportContext = createContext<{ reportId: string; limited: boolean } | null>(null);
